module.exports = __webpack_public_path__ + "img/excel.327c7ded.png";